// src/pages/PantallaRepasoIntro.jsx
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import fondo from '../assets/img_generales/fondo.png';
import asclepio from '../assets/img_roles/asclepio.jpg';
import './PantallaTutorial.css'; 

const template =
  'Antes de comenzar, {NOMBRE}, y para que logres sobrevivir este turno, repasaremos algunos conceptos básicos que debes saber.\n\n' +
  'Para esto, te dejaré con un viejo amigo que sabe mucho más de esto.';

export default function PantallaRepasoIntro() {
  const navigate = useNavigate();
  const nombreUsuario = useMemo(() => {
  const raw = (localStorage.getItem('usuario') || 'Estudiante').trim();
  return raw.toLowerCase();   // normaliza a minúsculas
}, []);
  const textTarget = useMemo(
    () => template.replace('{NOMBRE}', nombreUsuario),
    [nombreUsuario]
  );

  // typewriter
  const [typed, setTyped] = useState('');
  const [done, setDone] = useState(false);
  const idxRef = useRef(0);
  const speedRef = useRef(22);

  useEffect(() => {
    let raf;
    let last = performance.now();
    const step = (now) => {
      if (now - last >= speedRef.current) {
        last = now;
        const n = idxRef.current + 1;
        setTyped(textTarget.slice(0, n));
        idxRef.current = n;
        if (n >= textTarget.length) {
          setDone(true);
          return;
        }
      }
      raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [textTarget]);

  function irARepaso() {
    
    navigate('/nivel-repaso', { replace: true });
  }

  return (
    <div className="tutorial__wrap" style={{ backgroundImage: `url(${fondo})` }}>
      <div className="tutorial__card" role="dialog" aria-label="Introducción al repaso">
        <img src={asclepio} alt="Asclepio" className="tutorial__img" />
        <div className="tutorial__text">
          {typed.split('\n').map((line, i) => (
            <p key={i} className="tutorial__p">
              {line}
              {i === typed.split('\n').length - 1 && !done ? (
                <span className="tutorial__cursor" aria-hidden="true">|</span>
              ) : null}
            </p>
          ))}
        </div>
        {done && (
          <button className="tutorial__btn" onClick={irARepaso}>
            Ir al Repaso
          </button>
        )}
      </div>
    </div>
  );
}
